import React from "react";
import "./tituloModulo.css";

export default function SubTituloModulo({ subtitulo }) {
  return (
    <div className="subtitulo-modulo">
      <h3>{subtitulo}</h3>
    </div>
  );
}
